export const extintorChecklist = [
  {
    title: "Estado Fisico do Extintor",
    options: ["OK", "Danificado/Irregular", "Não aplicavel"],
  },
  {
    title: "Etiqueta de Inspeção",
    options: ["OK", "Danificado/Irregular", "Não aplicavel"],
  },
  {
    title: "Numeração",
    options: ["OK", "Danificado/Irregular", "Não aplicavel"],
  },
  {
    title: "Gatilhos",
    options: ["OK", "Danificado/Irregular", "Não aplicavel"],
  },
  {
    title: "Recarga",
    options: ["OK", "Danificado/Irregular", "Não aplicavel"],
  },
  {
    title: "Teste Hidrostático",
    options: ["OK", "Danificado/Irregular", "Não aplicavel"],
  },
  {
    title: "Manômetros",
    options: ["OK", "Danificado/Irregular", "Não aplicavel"],
  },
  {
    title: "Pino ( trava ) instalado em local correto",
    options: ["OK", "Danificado/Irregular", "Não aplicavel"],
  },
  {
    title: "Válvula de Segurança",
    options: ["OK", "Danificado/Irregular", "Não aplicavel"],
  },
  {
    title: "Lacre posicionado corretamente e não rompido",
    options: ["OK", "Danificado/Irregular", "Não aplicavel"],
  },
  {
    title: "Quadro de instrução de operação legível",
    options: ["OK", "Danificado/Irregular", "Não aplicavel"],
  },
  {
    title: "Verificar possiveis entupimentos (mangueiras, difusor)",
    options: ["OK", "Danificado/Irregular", "Não aplicavel"],
  },
  {
    title: "Sinalização de pisos e paredes",
    options: ["OK", "Irregular/Danificado", "Não aplicavel"],
  },
  {
    title: "Extintores Livres de obstrução (acesso livre)",
    options: ["SIM", "NÃO", "Não aplicavel"],
  },
  {
    title: "Cilindro de CO² está com o peso dentro do limite de 10% de perda",
    options: ["OK", "Danificado/Irregular", "Não aplicavel"],
  },
];

export const hidranteChecklist = [
  {
    title: "Estado Fisico da Caixa",
    options: ["OK", "Danificado/Irregular", "Não aplicavel"],
  },
  {
    title: "Numeração e Etiqueta de Inspeção",
    options: ["OK", "Danificado/Irregular", "Não aplicavel"],
  },
  {
    title: "Mangueiras",
    options: ["OK", "Danificado/Irregular", "Não aplicavel"],
  },
  {
    title: "Teste Hidrostático da Mangueira",
    options: ["OK", "Danificado/Irregular", "Não aplicavel"],
  },
  {
    title: "Bico regulável",
    options: ["OK", "Danificado/Irregular", "Não aplicavel"],
  },
  {
    title: "Chaves",
    options: ["OK", "Danificado/Irregular", "Não aplicavel"],
  },
  {
    title: "Conexões",
    options: ["OK", "Danificado/Irregular", "Não aplicavel"],
  },
  {
    title: "Hidrante em Condições Adequadas",
    options: ["OK", "Danificado/Irregular", "Não aplicavel"],
  },
  {
    title: "Pintura do Abrigo",
    options: ["OK", "Danificado/Irregular", "Não aplicavel"],
  },
  {
    title: "Pintura do Hidrante",
    options: ["OK", "Danificado/Irregular", "Não aplicavel"],
  },
];

export const iluminacaoChecklist = [
  {
    title: "Estado Fisico da Caixa",
    options: ["OK", "Danificado/Irregular", "Não aplicavel"],
  },
  {
    title: "Livre de obstrução",
    options: ["SIM", "NÃO", "Não aplicavel"],
  },
  {
    title: "Tomada de energia",
    options: ["OK", "Danificado/Irregular", "Não aplicavel"],
  },
  {
    title: "Funcionamento (puxar a tomada)",
    options: ["OK", "Danificado/Irregular", "Não aplicavel"],
  },
  {
    title: "Funcionamento dos LEDs",
    options: ["OK", "Danificado/Irregular", "Não aplicavel"],
  },
];

export const acionador_sireneChecklist = [
  {
    title: "Estado Fisico da Caixa",
    options: ["OK", "Danificado/Irregular", "Não aplicavel"],
  },
  {
    title: "Livre de obstrução",
    options: ["SIM", "NÃO", "Não aplicavel"],
  },
  {
    title: "Led intermitente verde",
    options: ["OK", "Danificado/Irregular", "Não aplicavel"],
  },
  {
    title: "Vidro de policarbonato",
    options: ["OK", "Danificado/Irregular", "Não aplicavel"],
  },
  {
    title: "Comunicação entre acionador e central",
    options: ["OK", "Danificado/Irregular", "Não aplicavel"],
  },
  {
    title: "Funcionamento (acionar)",
    options: ["OK", "Danificado/Irregular", "Não aplicavel"],
  },
  {
    title: "Estado da sirene",
    options: ["OK", "Danificado/Irregular", "Não aplicavel"],
  },
  {
    title: "Funcionamento (som)",
    options: ["OK", "Danificado/Irregular", "Não aplicavel"],
  },
];

export const maintenanceInfo = [
  {
    title: "REPARO",
    info: "Manutenções do tipo REPARO consistem em restaurar o bom estado de funcionamento, corrigir ou melhorar a condição danificada; remendar; remediar ou reparar. Ou seja, o reparo envolve o dano ou mau funcionamento de uma determinada peça ou equipamento como um todo.",
  },
  {
    title: "PERIÓDICA",
    info: "A manutenção PERIÓDICA geralmente envolve inspeções, lubrificação, ajustes, substituição de peças desgastadas, limpeza e outros procedimentos necessários para manter o equipamento em condições operacionais ideais.",
  },
  {
    title: "QUEBRA",
    info: "Como o próprio nome deste tipo de manutenção sugere, a manutenção de QUEBRA é o tipo de manutenção que é implementado apenas quando o maquinário ou item deixa de funcionar.",
  },
  {
    title: "SUBSTITUIÇÃO",
    info: "Manutenções do tipo SUBSTITUIÇÃO é o tipo de manutenção feita quando necessário fazer a troca do item por um novo, como a troca de um extintor vencido ou a troca de um extintor portatil para uma carreta.",
  },
  {
    title: "PREVENTIVA",
    info: "A manutenção PREVENTIVA tem a característica de ser planejada e programada com antecedência. É feita em períodos predeterminados ou de acordo com a necessidade e critérios de forma planejada e sistemática.",
  },
  {
    title: "CORRETIVA",
    info: "Manutenção CORRETIVA (conforme a Norma NBR 5462) é manutenção realizada após a falha ou pane do componente, para colocá-lo em funcionamento novamente",
  },
  {
    title: "PREDITIVA",
    info: "Manutenções do tipo PREDITIVA tem o foco em antecipar os defeitos e detectar qualquer funcionamento anormal antes que uma parada ou defeito não programado aconteça.",
  },
  {
    title: "PRODUTIVA ou TPM (Manutenção produtiva total)",
    info: "Manutenções como essa tem o objetivo de otimizar os processos objetivando a falha e defeito zero. Sua aplicação, além dos benefícios em produtividade e confiabilidade, desenvolve os operários a serem mais autônomos e terem mais conhecimentos da máquina ou aparelho. É a cultura do “da minha máquina cuido eu”",
  },
];
